/* eslint-disable class-methods-use-this */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckoutStep } from '@arc/unified-payments-frontend/shared-payment';

@Component({
  selector: 'payment-footer',
  templateUrl: './payment-footer.component.html',
  styleUrls: ['./payment-footer.component.scss'],
})
export class PaymentFooterComponent {
  @Input() translations: Record<string, string>;
  @Input() currentStep: CheckoutStep;
  @Input() subscriberAgreementUrl: string;
  @Input() sessionExitUrl: string;
  @Input() sessionCompleteUrl: string;
  @Input() paymentSucceeded: boolean;
  @Input() hasPayOtherAmountThrownAnError: boolean;
  @Input() showContactInformation: boolean;
  @Input() contactInformation: string;
  @Input() isAlternativePaymentMethodAvailable: boolean;

  @Output() sessionExitClicked = new EventEmitter();
  @Output() proceedToPaymentClicked = new EventEmitter();
  @Output() backFromSelectPaymentTypeClicked = new EventEmitter();
  @Output() backFromSelectPaymentMethodClicked = new EventEmitter();
  @Output() backFromConfirmPaymentClicked = new EventEmitter();
  @Output() reviewPaymentClicked = new EventEmitter();
  @Output() backFromReviewPaymentClicked = new EventEmitter();
  @Output() authorizePaymentClicked = new EventEmitter();
  @Output() returnToAppClicked = new EventEmitter();

  checkoutStep = CheckoutStep;

  public onSessionExitClicked(): void {
    this.sessionExitClicked.emit();
  }

  public onProceedToPaymentClicked() {
    this.proceedToPaymentClicked.emit();
  }

  public onBackFromSelectPaymentTypeClicked() {
    this.backFromSelectPaymentTypeClicked.emit();
  }

  public onBackFromSelectPaymentMethodClicked() {
    this.backFromSelectPaymentMethodClicked.emit();
  }

  public onBackFromConfirmPaymentClicked() {
    this.backFromConfirmPaymentClicked.emit();
  }

  public onReviewPaymentClicked() {
    this.reviewPaymentClicked.emit();
  }

  public onBackFromReviewPaymentClicked() {
    this.backFromReviewPaymentClicked.emit();
  }

  public onAuthorizePaymentClicked() {
    this.authorizePaymentClicked.emit();
  }

  public onReturnToAppClicked() {
    this.returnToAppClicked.emit();
  }

  public onPrintConfirmationClicked() {
    const printComponent = document.getElementById('printable');
    this.print(printComponent);
  }

  /* istanbul ignore next */
  public print(content: HTMLElement) {
    const style = this.getStyleByTextContent('#confirmationPrint');
    const printWindow = window.open('', '_blank', 'width=1000,height=600');
    printWindow.opener = null;
    printWindow.document.open();
    printWindow.document.write(
      `<html>
      <head>
        <title>Payment Confirmation</title>
        <style>
          ${style.innerHTML}
          @page {size: 210mm 297mm; margin: 0.5cm; }
        </style>
      </head>
      <body onload="window.print();window.close()">${content.innerHTML}</body>
    </html>`,
    );
    printWindow.document.close();
  }

  /* istanbul ignore next */
  private getStyleByTextContent(text: string) {
    return Array.prototype.slice
      .call(document.getElementsByTagName('style'))
      .find((el: HTMLElement) =>
        el.textContent.trim().includes(text.trim()),
      ) as HTMLElement;
  }
}
